var MessageCommunicator = function() {
  this.configure();
};

MessageCommunicator.prototype.configure = function() {
  if (!window.addEventListener) {
    window.attachEvent("onmessage", this.receive.bind(this));

  } else {
    window.addEventListener("message", this.receive.bind(this));
  }
};

MessageCommunicator.prototype.setReceiver = function(receiver) {
  this.receiver = receiver;

  return this;
};

MessageCommunicator.prototype.setReceiverDomain = function(receiverDomain) {
  this.receiverDomain = receiverDomain;

  return this;
};

MessageCommunicator.prototype.onMessage = function(callback) {
  this.messageCallback = callback;

  return this;
};

MessageCommunicator.prototype.send = function(topic, data) {
  // console.log("Send Message", window.location.pathname, topic);

  var message = JSON.stringify({
    topic: topic,
    data: data
  });

  if (this.receiver && this.receiverDomain) {
    this.receiver.postMessage(message, this.receiverDomain);

  } else {
    // console.log("Receiver or Receiver Domain not available");
  }
};

MessageCommunicator.prototype.getReceiver = function() {
  return this.receiver;
};

MessageCommunicator.prototype.removePortFromDomain = function(domain) {
  return domain.replace(/:\d+?$/, "");
};

MessageCommunicator.prototype.receive = function(e) {
  // Check to make sure that this message came from the correct domain.
  if (this.removePortFromDomain(e.origin) === this.removePortFromDomain(this.receiverDomain)) {
    var message = JSON.parse(e.data);

    // console.log("Receive Message", window.location.pathname, message.topic);

    if (this.messageCallback) {
      this.messageCallback(message.topic, message.data);
    }
  }
};

module.exports = MessageCommunicator;
